import React from "react";

export default function BillingStatement() {
  return <div>BillingStatement</div>;
}
